import actionTypes from "../actionTypes/tab";

export const changeTab = (payload) => ({
  payload,
  type: actionTypes.CHANGE_TAB,
});
